// extracted by mini-css-extract-plugin
export default {"textlight":"Cocacola_textlight__pM6N4","cocacolared":"Cocacola_cocacolared__H7ffi","firstpg":"Cocacola_firstpg__j5z9o"};